import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {ButtonGroup} from '../../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroup';
import {ButtonGroupSpacer} from '../../../../../libs/shared/ui/src/components/buttons/buttonGroup/buttonGroupSpacer';
import {useWorkspacesEditor} from './context/workspacesEditorContext';

/*
 * Styles.
 */

const StyledWrapperDiv = styled.div`
  background-color: ${(p) => p.theme.background};
  padding: 16px;
`;

/*
 * Component.
 */

export const WorkspacesEditorFooter: FC = () => {
  const {isSaveDisabled, onRequestCancelChanges, onRequestSaveChanges, isSavingWorkspaces} =
    useWorkspacesEditor();

  return (
    <StyledWrapperDiv>
      <ButtonGroup>
        <ButtonGroupSpacer />
        <Button onClick={onRequestCancelChanges}>
          <Trans id="workspaces-editor-footer-cancel">Cancel</Trans>
        </Button>
        {isSavingWorkspaces ? (
          <Button onClick={onRequestSaveChanges} variant={ButtonVariantsEnum.PRIMARY} isDisabled>
            <Trans id="workspaces-editor-footer-saving">Saving...</Trans>
          </Button>
        ) : (
          <Button
            onClick={onRequestSaveChanges}
            variant={ButtonVariantsEnum.PRIMARY}
            isDisabled={isSaveDisabled}
          >
            <Trans id="workspaces-editor-footer-save">Save</Trans>
          </Button>
        )}
      </ButtonGroup>
    </StyledWrapperDiv>
  );
};
